export type EventDatePreset =
  | "any"
  | "upcoming"
  | "today"
  | "next7"
  | "next30"
  | "past";

export const EVENT_DATE_PRESETS: { value: EventDatePreset; label: string }[] = [
  { value: "any", label: "Any date" },
  { value: "upcoming", label: "Upcoming" },
  { value: "today", label: "Today" },
  { value: "next7", label: "Next 7 days" },
  { value: "next30", label: "Next 30 days" },
  { value: "past", label: "Past" },
];

export function getEventDateRange(
  preset: EventDatePreset | string | null | undefined,
  now: Date = new Date(),
): { date_from?: string; date_to?: string } {
  if (!preset || preset === "any") return {};

  const startOfToday = new Date(now);
  startOfToday.setHours(0, 0, 0, 0);
  const endOfToday = new Date(now);
  endOfToday.setHours(23, 59, 59, 999);

  if (preset === "upcoming") {
    return { date_from: startOfToday.toISOString() };
  }
  if (preset === "today") {
    return {
      date_from: startOfToday.toISOString(),
      date_to: endOfToday.toISOString(),
    };
  }
  if (preset === "past") {
    return { date_to: now.toISOString() };
  }
  if (preset === "next7" || preset === "next30") {
    const lastDay = new Date(endOfToday);
    lastDay.setDate(lastDay.getDate() + (preset === "next7" ? 6 : 29));
    return {
      date_from: startOfToday.toISOString(),
      date_to: lastDay.toISOString(),
    };
  }

  return {};
}
